import { formatMoney } from '../../lib/money';

export function BarChart({ rows, currency = 'GBP' }: { rows: { label: string; value: number; currency?: string }[]; currency?: string }) {
  const max = Math.max(1, ...rows.map((row) => row.value));
  if (!rows.length) return <p className="text-sm text-[var(--bo-muted)]">Nothing in this period.</p>;
  return (
    <div className="space-y-2">
      {rows.map((row) => (
        <div key={row.label} className="grid grid-cols-[9rem_1fr_7rem] items-center gap-2 text-xs">
          <div className="truncate">{row.label}</div>
          <div className="h-2 rounded bg-gray-100 dark:bg-gray-800">
            <div className="h-2 rounded bg-[#895CF6]" style={{ width: `${Math.max(row.value > 0 ? 2 : 0, Math.round((row.value / max) * 100))}%` }} />
          </div>
          <div className="text-right tabular-nums">{formatMoney(row.value, row.currency || currency)}</div>
        </div>
      ))}
    </div>
  );
}
